import { useTranslation } from 'react-i18next';
import CampaignField from './fields/campaign-field/campaign-field.component';
import { useWatch } from 'react-hook-form';
import { useMemo } from 'react';
import { useListOffersQuery } from 'api/offers-domain/offers-domain';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import AutocompleteField from '../fields/autocomplete-field/autocomplete-field.component';
import {
  OfferParamsType,
  OfferStatusType,
} from 'api/offers-domain/offers-domain.types';
import { Typography } from '@mui/material';
import CheckboxField from '../fields/checkbox-field/checkbox-field.component';

const SendOfferForm = () => {
  const { t } = useTranslation();

  const selectedCampaign = useWatch({ name: 'campaign' });

  const requestParams: OfferParamsType = {
    count: 1000,
    page: 0,
    campaignId: selectedCampaign,
    offerstatus: OfferStatusType.ACTIVE,
  };

  const { data, isFetching } = useListOffersQuery(
    !!selectedCampaign ? requestParams : skipToken,
  );

  const offerListOptions = useMemo(
    () =>
      isFetching
        ? []
        : data?.offers
            ?.filter(offer => offer.distributionMode === 'ACTIVITY')
            .map(offer => ({
              id: offer?.offerId,
              label: offer?.title,
            })),
    [data, isFetching],
  );

  return (
    <>
      <Typography variant="body2" mb={2}>
        {t('page.customers.form.sendOffer.description')}
      </Typography>
      <CampaignField
        name="campaign"
        label={t('page.customers.form.sendOffer.campaign')}
        data-testid="SendOfferForm.IncTextField.Campaign"
      />
      <AutocompleteField
        name="loyaltyOffer"
        label={t('page.customers.form.sendOffer.loyaltyOffer')}
        options={offerListOptions}
        data-testid="SendOfferForm.IncTextField.LoyaltyOffer"
        disabled={!selectedCampaign}
        loading={isFetching}
      />
      <CheckboxField
        name="ignoreDistributionRules"
        label={t(
          'page.customers.form.sendOffer.ignoreRules.distribution.label',
        )}
        helperText={t(
          'page.customers.form.sendOffer.ignoreRules.distribution.helperText',
        )}
      />
      <CheckboxField
        name="ignoreRedistributionMode"
        label={t(
          'page.customers.form.sendOffer.ignoreRules.redistribution.label',
        )}
        helperText={t(
          'page.customers.form.sendOffer.ignoreRules.redistribution.helperText',
        )}
      />
      <CheckboxField
        name="ignoreBlackoutPeriod"
        label={t('page.customers.form.sendOffer.ignoreRules.blackout.label')}
        helperText={t(
          'page.customers.form.sendOffer.ignoreRules.blackout.helperText',
        )}
      />
    </>
  );
};

export default SendOfferForm;
